// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlockUploader-space1-wOBEg {
	margin-bottom: 6px !important;
}

.BlockUploader-space2-QNBNF {
	margin-bottom: 12px !important;
}

.BlockUploader-space3-IqhsC {
	margin-bottom: 18px !important;
}

.BlockUploader-space4-cnMPz {
	margin-bottom: 24px !important;
}

.BlockUploader-space5-R7R__ {
	margin-bottom: 30px !important;
}

.BlockUploader-space6-e5Opa {
	margin-bottom: 36px !important;
}

.BlockUploader-space7-TGkZf {
	margin-bottom: 42px !important;
}

.BlockUploader-spaceTop8-FPXfD {
	margin-bottom: 48px !important;
}

.BlockUploader-spaceTop1-IK30d {
	margin-top: 6px !important;
}

.BlockUploader-spaceTop2-XrvWi {
	margin-top: 12px !important;
}

.BlockUploader-spaceTop3-NQyyT {
	margin-top: 18px !important;
}

.BlockUploader-spaceTop4-OJ6tT {
	margin-top: 24px !important;
}

.BlockUploader-spaceTop5-YEa8u {
	margin-top: 30px !important;
}

.BlockUploader-spaceTop6-GPwWB {
	margin-top: 36px !important;
}

.BlockUploader-spaceTop7-ukrjY {
	margin-top: 42px !important;
}

.BlockUploader-spaceTop8-FPXfD {
	margin-top: 48px !important;
}

.BlockUploader-noMargin-pfeT8 {
	margin: 0px !important;
}

.BlockUploader-padding1-fU3ZP {
	padding-bottom: 6px !important;
}

.BlockUploader-padding2-P2jwQ {
	padding-bottom: 12px !important;
}

.BlockUploader-padding3-izHDf {
	padding-bottom: 18px !important;
}

.BlockUploader-padding4-CTYJx {
	padding-bottom: 24px !important;
}

.BlockUploader-padding5-IOsHO {
	padding-bottom: 30px !important;
}

.BlockUploader-padding6-tfC3D {
	padding-bottom: 36px !important;
}

.BlockUploader-padding7-DBisz {
	padding-bottom: 42px !important;
}

.BlockUploader-paddingTop1-grQER {
	padding-top: 6px !important;
}

.BlockUploader-paddingTop2-JZueE {
	padding-top: 12px !important;
}

.BlockUploader-paddingTop3-l6q2r {
	padding-top: 18px !important;
}

.BlockUploader-paddingTop4-SxtNR {
	padding-top: 24px !important;
}

.BlockUploader-paddingTop5-kmJAH {
	padding-top: 30px !important;
}

.BlockUploader-paddingTop6-fG8zv {
	padding-top: 36px !important;
}

.BlockUploader-paddingTop7-a1GZI {
	padding-top: 42px !important;
}

.BlockUploader-noPadding-b6DYR {
	padding: 0px !important;
}

.BlockUploader-textBold-Ev1xj {
	font-weight: 500 !important;
}

.BlockUploader-textBolder-Vzk0f {
	font-weight: 700 !important;
}

.BlockUploader-textNormal-vXfEF {
	font-weight: normal !important;
}

.BlockUploader-spaceBottom20-SGJfF {
	margin-bottom: 20px;
}

.BlockUploader-spaceBottom10-UdJR3 {
	margin-bottom: 10px;
}

.BlockUploader-marginNone-AoZOp {
	margin: 0;
}

.BlockUploader-spaceBottom15-HGO5l {
	margin-bottom: 15px;
}

.BlockUploader-marginTopNone-NQ24J {
	margin-top: 0;
}

.BlockUploader-spaceTop11-m8c_R {
	margin-top: 11px;
}

.BlockUploader-spaceTop21-JsGNM {
	margin-top: 21px;
}

.BlockUploader-spaceTop20-hHWtf {
	margin-top: 20px;
}

.BlockUploader-spaceTop10-svbVt {
	margin-top: 10px;
}

/*New Design Text Colors */

.BlockUploader-textDarkBlue-ogXQx {
	color: rgb(20, 39, 94) !important;
}

.BlockUploader-textLightBlue-Q_jTS {
	color: rgb(57, 87, 106) !important;
}

.BlockUploader-textLightSandleGreen-d_Wj6 {
	color: rgb(76, 86, 41) !important;
}

.BlockUploader-textLightBrown-y6rbF {
	color: rgb(115, 79, 33) !important;
}

.BlockUploader-textMediumMaroon-YxrB8 {
	color: rgb(87, 37, 51) !important;
}

.BlockUploader-textBrown-_PnYN {
	color: rgb(160, 47, 24) !important;
}

.BlockUploader-textMaroon-kj1g_ {
	color: rgb(155, 49, 67) !important;
}

.BlockUploader-textDarkBrown-MEO6S {
	color: rgb(83, 18, 16) !important;
}

.BlockUploader-textMediumBrown-rFj1H {
	color: rgb(142, 28, 10) !important;
}

.BlockUploader-textSkyBlue-yPmMt {
	color: rgb(37, 117, 141) !important;
}

.BlockUploader-textGray-vWuks {
	color: rgb(77, 65, 51) !important;
}

.BlockUploader-commonHeaderAdmin-IO1C4 {
	position: fixed !important;
}

.BlockUploader-adminLayout-AyAVf {
	padding-top: 64px !important;
}

.BlockUploader-box-EUNNG h2 {
	font-size: 21px;
	font-weight: 600;
}

.BlockUploader-exportLink-opuCx {
	margin-bottom: -29px;
}

.BlockUploader-blockCenter-N9TN0 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.BlockUploader-panelHeader-BEkUc {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.BlockUploader-currencyselect-xfdTl {
	width: 100%;
	margin-right: 0px;
}

.BlockUploader-panelHeader-BEkUc {
	overflow: hidden;
	position: relative;
}

.BlockUploader-mar0-O96fr {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.BlockUploader-blockCenter-N9TN0 {
		padding: 0px;
	}

	.BlockUploader-panelHeader-BEkUc {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.BlockUploader-sideAdminPageWrapper-FSHzd {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.BlockUploader-panelHeader-BEkUc {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.BlockUploader-table-t4Kje {
	display: table;
}

.BlockUploader-tableRow-jhLZe {
	display: table-row;
}

.BlockUploader-tableCell-UYIMc {
	display: table-cell;
	float: none;
}

.BlockUploader-formGroup-hbKPT {
	margin-bottom: 6px;
}

.BlockUploader-select-h6QOt {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.BlockUploader-noMargin-pfeT8 {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.BlockUploader-exportLink-opuCx {
	padding-top: 10px;
	padding-right: 10px;
}

.BlockUploader-labelTextNew-qcu0x {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.BlockUploader-displayInline-K9X0Y {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.BlockUploader-btnUPdate-VmqeI {
	display: inline-block;
}

.BlockUploader-btnModalDelete-HLqka {
	display: inline-block;
	margin-left: 15px;
}

.BlockUploader-radioBtn-SQs1A {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.BlockUploader-backgroundImg-UprCs {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.BlockUploader-btnUPdate-VmqeI {
		display: block;
		margin-bottom: 12px;
	}

	.BlockUploader-btnModalDelete-HLqka {
		display: block;
		margin-left: 0px;
	}

	.BlockUploader-btnWidth-GRR8m {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.BlockUploader-bannerImageBg-vwPeb {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.BlockUploader-bannerDelete-pgY3Q {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.BlockUploader-modalRoot-K5L8V {
	padding: 32px;
}

.BlockUploader-modalBorderBottom-wUnjA {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.BlockUploader-logInModalBody-v9RFm {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.BlockUploader-exportSection-zVisU {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.BlockUploader-exportSectionGridSub-j_pgv {
	grid-template-columns: 50% 49% !important;
}

.BlockUploader-exportText-KMR6l {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.BlockUploader-exportLinkImg-rQMA3 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.BlockUploader-vtrMiddle-G41cM {
	vertical-align: middle;
}

.BlockUploader-exportImg-yLqVh {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.BlockUploader-profileViewlabel-W8BVA {
	display: inline-block;
	width: 38%
}

.BlockUploader-profileViewMainContent-yxOnZ {
	display: inline-block;
	width: 62%;
}

.BlockUploader-profileViewMain-hpDfK {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.BlockUploader-profileViewInner-jQl8k {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.BlockUploader-profileImageSection-bbfNJ {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.BlockUploader-lastviewInner-peSZI {
	padding: 10px;
}

.BlockUploader-whyHostHoriLine-pLIWf {
	margin: 30px 0;
}

.BlockUploader-tableGrid-xBc4e {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.BlockUploader-headingContent-xQHmI {
	font-size: 18px;
	font-weight: 500;
}

.BlockUploader-refundTextColor-q8fAY {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.BlockUploader-dividerLine-UUoJz {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.BlockUploader-smallContent-mkzyO {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.BlockUploader-sideAdminPageWrapper-FSHzd {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.BlockUploader-sideAdminPageWrapper-FSHzd {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.BlockUploader-exportSection-zVisU {
		grid-template-columns: 100%;
	}

	.BlockUploader-exportSectionGridSub-j_pgv {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.BlockUploader-profileViewlabel-W8BVA {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.BlockUploader-profileViewMainContent-yxOnZ {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.BlockUploader-ChangeToUpperCase-rW1kn {
	text-transform: uppercase
}

.BlockUploader-noBorder-olmGG {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.BlockUploader-siteAdminHeading-hiidI {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.BlockUploader-siteAdminSubHeading-z326r {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.BlockUploader-adminFormDivider-_XTKs {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `BlockUploader-space1-wOBEg`,
	"space2": `BlockUploader-space2-QNBNF`,
	"space3": `BlockUploader-space3-IqhsC`,
	"space4": `BlockUploader-space4-cnMPz`,
	"space5": `BlockUploader-space5-R7R__`,
	"space6": `BlockUploader-space6-e5Opa`,
	"space7": `BlockUploader-space7-TGkZf`,
	"spaceTop8": `BlockUploader-spaceTop8-FPXfD`,
	"spaceTop1": `BlockUploader-spaceTop1-IK30d`,
	"spaceTop2": `BlockUploader-spaceTop2-XrvWi`,
	"spaceTop3": `BlockUploader-spaceTop3-NQyyT`,
	"spaceTop4": `BlockUploader-spaceTop4-OJ6tT`,
	"spaceTop5": `BlockUploader-spaceTop5-YEa8u`,
	"spaceTop6": `BlockUploader-spaceTop6-GPwWB`,
	"spaceTop7": `BlockUploader-spaceTop7-ukrjY`,
	"noMargin": `BlockUploader-noMargin-pfeT8`,
	"padding1": `BlockUploader-padding1-fU3ZP`,
	"padding2": `BlockUploader-padding2-P2jwQ`,
	"padding3": `BlockUploader-padding3-izHDf`,
	"padding4": `BlockUploader-padding4-CTYJx`,
	"padding5": `BlockUploader-padding5-IOsHO`,
	"padding6": `BlockUploader-padding6-tfC3D`,
	"padding7": `BlockUploader-padding7-DBisz`,
	"paddingTop1": `BlockUploader-paddingTop1-grQER`,
	"paddingTop2": `BlockUploader-paddingTop2-JZueE`,
	"paddingTop3": `BlockUploader-paddingTop3-l6q2r`,
	"paddingTop4": `BlockUploader-paddingTop4-SxtNR`,
	"paddingTop5": `BlockUploader-paddingTop5-kmJAH`,
	"paddingTop6": `BlockUploader-paddingTop6-fG8zv`,
	"paddingTop7": `BlockUploader-paddingTop7-a1GZI`,
	"noPadding": `BlockUploader-noPadding-b6DYR`,
	"textBold": `BlockUploader-textBold-Ev1xj`,
	"textBolder": `BlockUploader-textBolder-Vzk0f`,
	"textNormal": `BlockUploader-textNormal-vXfEF`,
	"spaceBottom20": `BlockUploader-spaceBottom20-SGJfF`,
	"spaceBottom10": `BlockUploader-spaceBottom10-UdJR3`,
	"marginNone": `BlockUploader-marginNone-AoZOp`,
	"spaceBottom15": `BlockUploader-spaceBottom15-HGO5l`,
	"marginTopNone": `BlockUploader-marginTopNone-NQ24J`,
	"spaceTop11": `BlockUploader-spaceTop11-m8c_R`,
	"spaceTop21": `BlockUploader-spaceTop21-JsGNM`,
	"spaceTop20": `BlockUploader-spaceTop20-hHWtf`,
	"spaceTop10": `BlockUploader-spaceTop10-svbVt`,
	"textDarkBlue": `BlockUploader-textDarkBlue-ogXQx`,
	"textLightBlue": `BlockUploader-textLightBlue-Q_jTS`,
	"textLightSandleGreen": `BlockUploader-textLightSandleGreen-d_Wj6`,
	"textLightBrown": `BlockUploader-textLightBrown-y6rbF`,
	"textMediumMaroon": `BlockUploader-textMediumMaroon-YxrB8`,
	"textBrown": `BlockUploader-textBrown-_PnYN`,
	"textMaroon": `BlockUploader-textMaroon-kj1g_`,
	"textDarkBrown": `BlockUploader-textDarkBrown-MEO6S`,
	"textMediumBrown": `BlockUploader-textMediumBrown-rFj1H`,
	"textSkyBlue": `BlockUploader-textSkyBlue-yPmMt`,
	"textGray": `BlockUploader-textGray-vWuks`,
	"commonHeaderAdmin": `BlockUploader-commonHeaderAdmin-IO1C4`,
	"adminLayout": `BlockUploader-adminLayout-AyAVf`,
	"box": `BlockUploader-box-EUNNG`,
	"exportLink": `BlockUploader-exportLink-opuCx`,
	"blockCenter": `BlockUploader-blockCenter-N9TN0`,
	"panelHeader": `BlockUploader-panelHeader-BEkUc`,
	"currencyselect": `BlockUploader-currencyselect-xfdTl`,
	"mar0": `BlockUploader-mar0-O96fr`,
	"sideAdminPageWrapper": `BlockUploader-sideAdminPageWrapper-FSHzd`,
	"table": `BlockUploader-table-t4Kje`,
	"tableRow": `BlockUploader-tableRow-jhLZe`,
	"tableCell": `BlockUploader-tableCell-UYIMc`,
	"formGroup": `BlockUploader-formGroup-hbKPT`,
	"select": `BlockUploader-select-h6QOt`,
	"labelTextNew": `BlockUploader-labelTextNew-qcu0x`,
	"displayInline": `BlockUploader-displayInline-K9X0Y`,
	"btnUPdate": `BlockUploader-btnUPdate-VmqeI`,
	"btnModalDelete": `BlockUploader-btnModalDelete-HLqka`,
	"radioBtn": `BlockUploader-radioBtn-SQs1A`,
	"backgroundImg": `BlockUploader-backgroundImg-UprCs`,
	"btnWidth": `BlockUploader-btnWidth-GRR8m`,
	"bannerImageBg": `BlockUploader-bannerImageBg-vwPeb`,
	"bannerDelete": `BlockUploader-bannerDelete-pgY3Q`,
	"modalRoot": `BlockUploader-modalRoot-K5L8V`,
	"modalBorderBottom": `BlockUploader-modalBorderBottom-wUnjA`,
	"logInModalBody": `BlockUploader-logInModalBody-v9RFm`,
	"exportSection": `BlockUploader-exportSection-zVisU`,
	"exportSectionGridSub": `BlockUploader-exportSectionGridSub-j_pgv`,
	"exportText": `BlockUploader-exportText-KMR6l`,
	"exportLinkImg": `BlockUploader-exportLinkImg-rQMA3`,
	"vtrMiddle": `BlockUploader-vtrMiddle-G41cM`,
	"exportImg": `BlockUploader-exportImg-yLqVh`,
	"profileViewlabel": `BlockUploader-profileViewlabel-W8BVA`,
	"profileViewMainContent": `BlockUploader-profileViewMainContent-yxOnZ`,
	"profileViewMain": `BlockUploader-profileViewMain-hpDfK`,
	"profileViewInner": `BlockUploader-profileViewInner-jQl8k`,
	"profileImageSection": `BlockUploader-profileImageSection-bbfNJ`,
	"lastviewInner": `BlockUploader-lastviewInner-peSZI`,
	"whyHostHoriLine": `BlockUploader-whyHostHoriLine-pLIWf`,
	"tableGrid": `BlockUploader-tableGrid-xBc4e`,
	"headingContent": `BlockUploader-headingContent-xQHmI`,
	"refundTextColor": `BlockUploader-refundTextColor-q8fAY`,
	"dividerLine": `BlockUploader-dividerLine-UUoJz`,
	"smallContent": `BlockUploader-smallContent-mkzyO`,
	"ChangeToUpperCase": `BlockUploader-ChangeToUpperCase-rW1kn`,
	"noBorder": `BlockUploader-noBorder-olmGG`,
	"siteAdminHeading": `BlockUploader-siteAdminHeading-hiidI`,
	"siteAdminSubHeading": `BlockUploader-siteAdminSubHeading-z326r`,
	"adminFormDivider": `BlockUploader-adminFormDivider-_XTKs`
};
module.exports = ___CSS_LOADER_EXPORT___;
